<template>
  <div class="wrap">
    <ConstructionSharingDialog ref="constructionSharingDialog" :currentConstruction="currentConstruction"></ConstructionSharingDialog>
    <div class="head">
      <div class="title">{{ currentConstruction.cloud_construction_name }}</div>
      <button class="share-button" @click="$refs.constructionSharingDialog.show()" v-if="currentConstruction.is_owner">共有</button>
    </div>
    <div class="folder-list">
      <div class="folder">
        <router-link :to="{ name: 'create-kokuban-input' }">書類</router-link>
      </div>
      <div class="folder">
        <router-link :to="{ name: 'create-kokuban-output' }">黒板</router-link>
      </div>
      <div class="folder">
        <router-link :to="{ name: 'photo-list' }">写真</router-link>
      </div>
    </div>
    <div class="delete-folder-list">
      <div class="folder">
        <router-link :to="{ name: 'deleted-kokuban-list' }">削除された黒板</router-link>
      </div>
      <div class="folder">
        <router-link :to="{ name: 'deleted-photo-list' }">削除された写真</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConstructionFolder',
  components: {
    ConstructionSharingDialog: () => import('../../../components/ui/ConstructionSharingDialog.vue')
  },
  props: {
    currentConstruction: Object
  }
}
</script>

<style scoped>
.wrap {
  padding: 3rem;
}
.head {
  border-bottom: solid 1px #333;
  padding: 2rem 1rem;
}
.title {
  display: inline-block;
  font-size: 1.4rem;
  font-weight: bold;
  width: calc(100% - 100px);
}
.share-button {
  background-color: #666;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0.5rem 1rem;
  width: 100px;
}
.folder-list {
  padding: 3rem 1rem;
  border-bottom: solid 1px #333;
}
.delete-folder-list {
  padding: 3rem 1rem;
}
.folder {
  padding: 0.8rem 0;
}
.folder a {
  display: block;
  border: solid 1px #ccc;
  color: #333;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: bold;
  padding: 1.5rem 2rem;
  text-decoration: none;
}
</style>